import type { ComponentPropsWithoutRef } from "react";
import { forwardRef } from "react";

type AdyenWidgetRefProps = ComponentPropsWithoutRef<"div">;

const AdyenWidgetRef = forwardRef<HTMLDivElement, AdyenWidgetRefProps>(
  (props, ref) => {
    return (
      <div
        ref={ref}
        data-testid="adyen-dropin"
        className="scroll-mt-[7.5rem]"
        {...props}
      />
    );
  },
);

export default AdyenWidgetRef;
